export default {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.black,
			typography: theme.typography.caption,
			marginBottom: 8,
			'&.Mui-focused': {
				color: theme.palette.black,
			},
		}),
	},
}
